<template>
  <b-container v-if="stripeLoaded">
    <div v-if="isValidLink">
      <div v-if="!isPayCompleted" class="payment-form">
        <b-row>
          <b-col>
            <div class="flex-center">
              <img alt="Logo" src="@/assets/logo.png" />
            </div>
          </b-col>
          <b-col cols="12" lg="12"><label class="card-label">Email:</label></b-col>
          <b-col cols="12" lg="12">
            <b-form-input
              type="email"
              v-model.trim="email"
              @input="setTouched('email')"
              :class="v$.email.$error ? 'is-invalid' : ''"
              disabled
              placeholder="Enter Your Email"
            ></b-form-input>
            <div v-for="error of v$.email.$errors" class="invalid-feedback" :key="error.$uid">
              {{ error.$message }}
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="12">
            <label class="card-label">Personal Details</label>
            <div id="address-element"></div>
          </b-col>
          <b-col cols="12" lg="12">
            <label class="card-label">Card Number</label>
            <div id="card-element"></div>
          </b-col>
          <b-col cols="12">
            <div class="flex-center mt-3">
              <b-form-checkbox v-model="isAgreeTermsConditions" name="isAgreeTermsConditions" :disabled="isPayLoading">
                <b
                  >I agree to XtraPension's
                  <a href="https://www.xtrapension.com/terms" target="_blank">Terms & Conditions</a></b
                >
              </b-form-checkbox>
            </div>
          </b-col>
          <b-col cols="12" lg="12">
            <template v-if="isPayLoading">
              <div class="spinner-container p-3">
                <b-spinner></b-spinner>
              </div>
            </template>
            <div class="flex-center">
              <button class="btn-main" :disabled="isPayLoading || !isAgreeTermsConditions" @click="pay">
                Update payment card
              </button>
            </div>
            <div class="flex-center invalid-feedback" v-for="error of v$.email.$errors" :key="error.$uid">
              {{ error.$message }}
            </div>
            <div class="flex-center invalid-feedback">
              {{ stripeValidationError }}
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-else class="pay-completed-form">
        <b-row>
          <b-col>
            <div class="flex-center">
              <img alt="Logo" src="@/assets/logo.png" />
            </div>
          </b-col>
          <b-col cols="12" lg="12">
            <div class="flex-center">
              <h1>Thank you for updating your payment card!</h1>
              <p class="mt-3 mb-3">A receipt has been emailed to you. (Check your spam/junk folder)</p>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <div v-else class="invalid-container">
      <div class="flex-center">
        <img alt="Logo" class="p-3" src="@/assets/logo.png" />
        <h3 class="text-center">This link is not valid.</h3>
      </div>
    </div>
  </b-container>
  <b-container v-else>
    <b-row>
      <div class="flex-center">
        <div class="spinner-container p-3">
          <b-spinner></b-spinner>
        </div>
      </div>
    </b-row>
  </b-container>
</template>

<script>
import StripeService from '@/services/stripe-service/stripe.service';
import CardService from '@/services/card-service/card.service';
import useVuelidate from '@vuelidate/core';
import { required, email, helpers } from '@vuelidate/validators';
import { toast } from 'vue3-toastify';
import '../HomeView/HomeView.scss';
export default {
  computed: {
    currencySymbol() {
      let currencySymbol = 'US $';
      if (this.currencyCode === 'EUR') {
        currencySymbol = '€';
      } else if (this.currencyCode === 'CAD') {
        currencySymbol = 'CA $';
      } else if (this.currencyCode === 'AUD') {
        currencySymbol = 'AU $';
      } else if (this.currencyCode === 'NZD') {
        currencySymbol = 'NZ $';
      } else if (this.currencyCode === 'ZAR') {
        currencySymbol = 'R';
      }
      return currencySymbol;
    }
  },
  data() {
    return {
      v$: useVuelidate(),
      stripeLoaded: false,
      isPayLoading: false,
      isPayCompleted: false,
      payCompletedId: null,
      stripe: null,
      cardElement: null,
      addressElement: null,
      fullName: null,
      firstName: null,
      lastName: null,
      shippingAddress: null,
      phone: null,
      email: '',
      paymentId: this.$route.params.id,
      stripeValidationError: '',
      amount: 10000,
      isAgreeTermsConditions: false,
      productName: '',
      customerId: '',
      currencyCode: '',
      isValidLink: false
    };
  },
  validations() {
    return {
      email: {
        required: helpers.withMessage('Email address required', required),
        email
      }
    };
  },
  mounted() {
    if (this.$route?.params?.id) {
      this.getPaymentInfo(this.$route.params.id);
    } else this.$router.push('/');
  },
  methods: {
    formatAmount(amount) {
      return amount / 100;
    },
    async getPaymentInfo(id) {
      this.showStripeLoading();
      try {
        const { status, email, firstName, lastName, phone, address, customerId } = await CardService.getPaymentInfo({
          id: id
        });
        console.log('Get Payment Infor Response', status, email, firstName, lastName, phone, address);
        if (status === 'Success' && email && customerId) {
          this.email = email;
          this.firstName = firstName ?? null;
          this.lastName = lastName ?? null;
          this.phone = phone ?? null;
          this.shippingAddress = address ?? null;
          this.customerId = customerId ?? '';
          // eslint-disable-next-line no-undef
          this.stripe = await Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
          this.isValidLink = true;
          await this.hideStripeLoading();
          await this.createAndMountFormElements();
        }
      } catch (err) {
        toast.error(err.message ?? 'Oops, Something Went Wrong');
        console.log(err);
        this.isValidLink = false;
        this.hideStripeLoading();
      }
    },
    showStripeLoading() {
      this.stripeLoaded = false;
    },
    hideStripeLoading() {
      this.stripeLoaded = true;
    },
    setTouched(theModel) {
      if (theModel === 'email' || theModel == 'all') {
        this.v$.email.$touch();
      }
    },
    async createAndMountFormElements() {
      const elements = this.stripe.elements();
      this.cardElement = elements.create('card', {
        hidePostalCode: true
      });
      this.cardElement.mount('#card-element');
      let options = {
        mode: 'billing',
        fields: {
          phone: 'always',
          name: 'auto'
        },
        display: {
          name: 'split'
        },
        validation: {
          phone: {
            required: 'always'
          }
        }
      };

      let defaultValues = {};

      if (this.firstName) {
        defaultValues.firstName = this.firstName;
      }
      if (this.lastName) {
        defaultValues.lastName = this.lastName;
      }
      if (this.phone) {
        defaultValues.phone = this.phone;
      }
      if (this.shippingAddress) {
        defaultValues.address = this.shippingAddress;
      }

      if (defaultValues) {
        options = {
          ...options,
          defaultValues: defaultValues
        };
      }

      this.addressElement = elements.create('address', options);
      this.addressElement.mount('#address-element');

      this.cardElement.on('change', this.setValidationCardError);
      this.addressElement.on('change', this.setValidationError);
    },
    setValidationCardError(event) {
      this.stripeValidationError = event.error ? event.error.message : '';
    },
    setValidationError(event) {
      this.stripeValidationError = event.error ? event.error.message : '';
      if (event.complete) {
        this.shippingAddress = event.value.address;
        this.fullName = event.value.name;
        this.firstName = event.value.firstName;
        this.lastName = event.value.lastName;
        this.phone = event.value.phone;
      } else {
        console.log('sss');
        this.shippingAddress = null;
        this.fullName = null;
        this.firstName = null;
        this.lastName = null;
        this.phone = null;
      }
    },
    async pay() {
      try {
        this.setTouched('all');

        if (this.v$.$invalid) {
          return;
        }

        if (!(this.fullName && this.phone && this.shippingAddress && this.email)) {
          this.stripeValidationError = 'Fill in your personal data!';
          return;
        }

        this.showPayLoading();

        const createResp = await StripeService.createSetupIntent({
          customerId: this.customerId
        });

        if (createResp.error) {
          throw new Error(createResp.error);
        }

        const clientSecret = createResp.clientSecret;
        if (!clientSecret) {
          throw new Error('No client secret returned from server');
        }

        const result = await this.stripe.confirmCardSetup(clientSecret, {
          payment_method: {
            card: this.cardElement,
            billing_details: {
              name: this.fullName,
              email: this.email,
              phone: this.phone,
              address: this.shippingAddress
            }
          }
        });
        await this.handleSetupResult(result);
      } catch (error) {
        console.error(error);
        this.hidePayLoading();
        toast.error(error.message ?? 'Oops, Something Went Wrong');
        this.stripeValidationError = error.message ?? 'Something went wrong';
      }
    },

    async handleSetupResult(result) {
      try {
        if (result.error) {
          this.stripeValidationError = result.error.message;
          toast.error(result.error.message ?? 'Oops, Something Went Wrong');
          this.hidePayLoading();
          return;
        }
        const setupIntent = result.setupIntent;
        const paymentMethodId = setupIntent.payment_method;
        const setupIntentId = setupIntent.id;

        await StripeService.attachPaymentMethod({
          customerId: this.customerId,
          paymentMethodId: paymentMethodId
        });

        const res = await CardService.sendPaymentInfo({
          appId: this.paymentId,
          paymentId: this.paymentId,
          paymentMethod: paymentMethodId,
          customer: this.customerId ?? null
        });

        if (res?.status === 'Success') {
          this.isPayCompleted = true;
          this.payCompletedId = setupIntentId;
          toast.success('Card saved successfully');
        } else {
          toast.error(res?.status ?? 'Failed to save payment method on server');
        }

        this.hidePayLoading();
      } catch (err) {
        console.error(err);
        this.hidePayLoading();
        toast.error(err.message ?? 'Oops, Something Went Wrong');
      }
    },
    showPayLoading() {
      this.isPayLoading = true;
    },
    hidePayLoading() {
      this.isPayLoading = false;
    },
    navigateToForm(id) {
      this.$router.push({ name: 'form', params: { id: id } });
    }
  }
};
</script>
